import { HealthCheckScopeMode } from '../../Interfaces/IHealthCheckRule';

/**
 * Beschriftungen fuer den Geltungsbereich einer Health-Check-Regel (#1283).
 *
 * Reine Funktionen, damit die Zeilenkomponente nur noch anzeigt: die Frage
 * „was steht im geschlossenen Feld?" und „wie viele Chips zeige ich?" ist
 * Textlogik und laesst sich ohne Oberflaeche pruefen.
 */

/**
 * Was im geschlossenen Auswahlfeld steht.
 *
 * Bewusst nur die Anzahl statt der Namen: die Spalte soll unabhaengig davon,
 * ob eine oder zwoelf Rechtsgeschaeftsarten gewaehlt sind, gleich breit
 * bleiben, damit die Tabellenstruktur ruhig bleibt.
 */
export const selectionCountLabel = (count: number) =>
  count === 0 ? '' : `${count} ausgewählt`;

/**
 * Ueberschrift der Zusatzzeile unter einer Regel.
 *
 * „Nur ausgewaehlte" und „Alle ausser den ausgewaehlten" bedeuten das Gegenteil
 * voneinander — dieselbe Beschriftung waere an einer der beiden Stellen
 * schlicht falsch. `null` heisst: keine Zusatzzeile.
 */
export const scopeSelectionSummary = (
  scopeMode: HealthCheckScopeMode,
  count: number
): string | null => {
  if (scopeMode === 'all' || count === 0) {
    return null;
  }

  return scopeMode === 'include'
    ? `Ausgewählt: ${count}`
    : `Ausgeschlossen: ${count}`;
};

/**
 * Teilt eine Liste in die sichtbaren Eintraege und die Zahl der uebrigen.
 *
 * Ein einzelner Mehreintrag wird nicht abgeschnitten: „+1 weitere" braucht
 * genauso viel Platz wie der Chip selbst und sagt weniger.
 */
export const splitVisibleItems = <T>(
  items: T[],
  maxVisible: number
): { visible: T[]; hiddenCount: number } =>
  items.length <= maxVisible + 1
    ? { visible: items, hiddenCount: 0 }
    : {
        visible: items.slice(0, maxVisible),
        hiddenCount: items.length - maxVisible,
      };
